import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import { Document, Page } from '@react-pdf/renderer';

interface DocumentViewerProps {
  open: boolean;
  document: {
    name: string;
    type: string;
    url: string;
  };
  onClose: () => void;
}

export const DocumentViewer: React.FC<DocumentViewerProps> = ({
  open,
  document,
  onClose
}) => {
  const [numPages, setNumPages] = React.useState<number>(1);
  const [pageNumber, setPageNumber] = React.useState(1);

  return (
    <Paper elevation={2} sx={{ p: 2 }}>
      <Typography variant="h6" gutterBottom>
        {document.name}
      </Typography>
      <Box sx={{ height: '60vh', overflow: 'auto' }}>
        {document.type === 'application/pdf' ? (
          <object
            data={document.url}
            type="application/pdf"
            width="100%"
            height="100%"
          >
            <p>PDF cannot be displayed. <a href={document.url}>Download Instead</a></p>
          </object>
        ) : (
          <iframe
            src={document.url}
            style={{ width: '100%', height: '100%', border: 'none' }}
            title={document.name}
          />
        )}
      </Box>
    </Paper>
  );
}; 